import { useState } from 'react';

import EditIcon from '@mui/icons-material/Edit';
import ReplayIcon from '@mui/icons-material/Replay';
import { useRedirect, ListButton, useNotify, TopToolbar, DeleteButton, Button } from 'react-admin';

import { CreateOfferOrderRefundModal } from './components/CreateOfferOrderRefundModal';
import { UpdateOfferOrderStatusModal } from './components/UpdateOfferOrderStatusModal';
import { UpdateOfferOrderActionButton } from './UpdateOfferOrderActionButton';

export const OfferOrderActions = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [isUpdateStatusModalVisible, setIsUpdateStatusModalVisible] = useState<boolean>(false);
  const [isRefundModalVisible, setIsRefundModalVisible] = useState<boolean>(false);

  const onUpdateStatus = () => {
    setIsUpdateStatusModalVisible(true);
  };

  const onRefundPayment = () => {
    setIsRefundModalVisible(true);
  };

  return (
    <TopToolbar>
      <Button label='Status' onClick={onUpdateStatus} startIcon={<EditIcon />} />
      <Button label='Refund' onClick={onRefundPayment} startIcon={<ReplayIcon />} />
      <UpdateOfferOrderActionButton />
      <DeleteButton
        label='Delete'
        mutationMode='pessimistic'
        confirmContent='Are you sure you want to delete the offer order?'
        confirmTitle='Delete Offer Order'
        mutationOptions={{
          onSuccess: () => {
            notify(`Offer order was successfully deleted.`, {
              type: 'success',
              undoable: true,
            });
          },
          onSettled: () => {
            redirect('/offer-orders');
          },
          onError: err => {
            notify(`Error deleting offer order: ${err}`, {
              type: 'error',
            });
          },
        }}
      />
      <ListButton />
      <CreateOfferOrderRefundModal isOpen={isRefundModalVisible} onClose={() => setIsRefundModalVisible(false)} />
      <UpdateOfferOrderStatusModal
        isOpen={isUpdateStatusModalVisible}
        onClose={() => setIsUpdateStatusModalVisible(false)}
      />
    </TopToolbar>
  );
};
